import { gql, type TypedDocumentNode, useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import type { Query, QuerySecureGlobalDownloadArgs } from '@/types/GraphqlSchema';

export type SecureGlobalDownloadQueryData = Pick<Query, 'secureGlobalDownload'>;

export const SECURE_GLOBAL_DOWNLOAD_QUERY: TypedDocumentNode<
  SecureGlobalDownloadQueryData,
  QuerySecureGlobalDownloadArgs
> = gql`
  query secureGlobalDownload($id: ID!) {
    secureGlobalDownload(
      id: $id
    ) {
      url
      filename
      downloadMessage
    }
  }
`;

export const useSecureGlobalDownload = (id: string | null) => {
  const [getGlobalDownload, { loading, data, error }] = useLazyQuery(SECURE_GLOBAL_DOWNLOAD_QUERY, {
    fetchPolicy: 'network-only',
  });

  const downloadDocument = useCallback((): void => {
    if (!id) return;

    getGlobalDownload({
      variables: { id },
    });
  }, [id, getGlobalDownload]);

  return {
    downloadDocument,
    data,
    loading,
    error,
  };
};
